import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <div className="hero-section">
        <div className="heart-decoration">💕</div>
        <h1 className="app-title">LoveSpace</h1>
        <p className="app-subtitle">Couple App for Daily Love</p>
        
        <div className="features">
          <p>✨ Daily love notes to brighten your day</p>
          <p>💕 Shared to-do lists for your adventures</p>
          <p>🎯 Fun quizzes to know each other better</p>
          <p>👫 Private space just for you two</p>
        </div>

        <div className="auth-buttons">
          <Link to="/signin" className="btn btn-primary">Sign In</Link>
          <Link to="/signup" className="btn btn-secondary">Sign Up</Link>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
